import * as React from 'react';
import { connect } from 'react-redux';
import {getReLoginURL, isDynaGro} from '../../config'
import {
    stopLoading,
  } from '../../actions/actions';

export interface IReLoginProps {
    stopLoading(): void;
}

const mapStateToProps = (state: any): any => {
    return {
    };
  };
const mapDispatchToProps = (dispatch: any) => {
    return {
        stopLoading: () => {
            dispatch(stopLoading())
        },
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ReLogin extends React.Component<IReLoginProps>{

    componentDidMount() {
        this.props.stopLoading();
    }
    onLoginClicked() {
        window.open(getReLoginURL(), "_self");
      }

    render() {

        const imageSource = isDynaGro() ? require('../Home/img/Loveland_logo.svg') : require('../Home/img/ProvenAndLoveland.svg');
        return(
            <div className="relogin-wrapper" onClick={() => this.onLoginClicked()}>
                <div className="relogin-header">
                    <div className="relogin-headline">Login Required</div>
                    <img src={imageSource} className="loveland-logo" />
                    <div className="optionText">Click here to login using your Nutrien account</div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ReLogin/ReLogin.tsx